import AiGuidelinesPage from './aiGuidelines'

export default AiGuidelinesPage
